
import { Component } from 'react';

import { hideDialog, openDialog } from '../../../base/dialog';
import { connect } from '../../../base/redux';

import { RecordingConsentDialog } from './web';

type Props = {

    /**
     * The local participant object.
     */
    _localParticipant: Object,

    /**
     * Whether the consent modal should be shown.
     */
    _shouldShowConsentModal: boolean,

    /**
     * The redux dispatch function.
     */
    dispatch: Function
}

/**
 * Component that manages the recording consent modal display.
 * This component automatically opens the consent dialog when needed.
 */
class RecordingConsentModalManager extends Component<Props> {
    /**
     * Implements React's {@link Component#componentDidUpdate()}.
     *
     * @inheritdoc
     * @returns {void}
     */
    componentDidUpdate(prevProps: Props) {
        const { _shouldShowConsentModal, dispatch, recordingConset } = this.props;

        // If consent modal should be shown and wasn't shown before
        if (_shouldShowConsentModal && !prevProps._shouldShowConsentModal && recordingConset === 1) {
            dispatch(openDialog(RecordingConsentDialog));
        } else if (!_shouldShowConsentModal && prevProps._shouldShowConsentModal) {
            dispatch(hideDialog(RecordingConsentDialog));
        }
    }

    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        // This component doesn't render anything visible
        // It just manages the modal state
        return null;
    }
}

/**
 * Maps (parts of) the Redux state to the associated props for the
 * {@code RecordingConsentModalManager} component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {{
 *     _localParticipant: Object,
 *     _shouldShowConsentModal: boolean
 * }}
 */
function mapStateToProps(state: Object) {
    const participants = state['features/base/participants'];
    const _localParticipant = participants.find(p => p.local);
    const recordingConset = state['features/base/jwt']?.meetingDetails?.settings?.RECORDING_CONSENT_DIALOG;


    return {
        _localParticipant,
        _shouldShowConsentModal: _localParticipant?.isShowConsentModal || false,
        recordingConset
    };
}

export default connect(mapStateToProps)(RecordingConsentModalManager);
